export default function handleError(error) {
    const { message, name, response } = error;

    if (message === 'Network Error') // We could not connect to api
        return { name: 'ServiceUnavailable', status: 503, message: 'Service Unavailable' };

    if (response)
        if (response.status === 400 && response.data.Message === 'incorrect_username_or_password')
            return { name: name, status: response.status, message: 'Incorrect Username or Password' };
        else
            return { name: name, status: response.status, message: 'Unauthorised User' };
    return { name: name, message: message };
}